import http from '../http'

export default {
  // 获取国家列表（包括区号）
  getCountryList(data: object = {}, option: object = {}) {
    return http.post('/basic/country/list_v3', data, option)
  },
  // 查询省市区
  getAreaList(data: object, option: object = {}) {
    return http.post('/basic/all', data, option)
  },
  // 获取站点列表
  getSiteList(data: object = {}, option: object = {}) {
    return http.post('/corp/scmc/site_corp/query_by_mall', data, option)
  },

  // 获取货币符号列表
  getCurrencyList(data: object = {}, option: object = {}) {
    return http.post('/basic/currency/list_v2', data, option)
  },

  // 获取COD货到付款设置(Mall)
  getLogistics(data: object, option: object = {}) {
    return http.post('/scmc/logistics/cod/setting/mall', data, option)
  },

  // 上传文件
  uploadFile(data: object, option: object = {}) {
    return http.post('/file/oss/upload/single', data, option)
  },
}
